import { render, staticRenderFns } from "./DetectionDetailComponent.vue?vue&type=template&id=68230020&scoped=true"
import script from "./DetectionDetailComponent.vue?vue&type=script&lang=js"
export * from "./DetectionDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68230020",
  null
  
)

export default component.exports